import { getBadgeColorForRole } from "@common";

export function getUserInfoItems(user) {
  return [
    {
      label: "Full Name",
      value: user.full_name,
      badge: false,
    },
    {
      label: "Email",
      value: user.email,
      badge: false,
    },
    {
      label: "Role",
      value: user.role_display || user.role_name,
      badge: true,
      badgeColorKey: getBadgeColorForRole(user.role),
    },
    ...(user.clinic && user.clinic.length > 0
      ? [
          {
            label: "Assigned Clinics",
            value: user.clinic.join(", "),
            badge: true,
            badgeColor: "bg-palette-indigo-muted text-palette-indigo-heading font-semibold",
          },
        ]
      : []),
    ...(user.phone_number
      ? [
          {
            label: "Phone Number",
            value: user.phone_number,
            badge: false,
          },
        ]
      : []),
    {
      label: "Status",
      value: user.status,
      badge: true,
      badgeColor:
        user.status === "active"
          ? "bg-palette-emerald-muted text-smiles-green font-semibold"
          : user.status === "inactive"
            ? "bg-palette-slate-muted text-smiles-gray font-semibold"
            : "bg-palette-red-muted text-palette-red-heading font-semibold",
    },
  ];
}

export function getPermissionsItems(user) {
  return [
    {
      label: "Can manage users",
      value: user.can_manage_users ? "Yes" : "No",
      badge: true,
      badgeColor: user.can_manage_users
        ? "bg-palette-emerald-muted text-smiles-green font-semibold"
        : "bg-palette-slate-muted text-smiles-gray font-semibold",
    },
    {
      label: "Can view data",
      value: user.can_view_data ? "Yes" : "No",
      badge: true,
      badgeColor: user.can_view_data
        ? "bg-palette-emerald-muted text-smiles-green font-semibold"
        : "bg-palette-slate-muted text-smiles-gray font-semibold",
    },
    {
      label: "Can perform actions",
      value: user.can_do_anything ? "Yes" : "No",
      badge: true,
      badgeColor: user.can_do_anything
        ? "bg-palette-emerald-muted text-smiles-green font-semibold"
        : "bg-palette-slate-muted text-smiles-gray font-semibold",
    },
  ];
}
